<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>

            <div style="width:100%">
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:150px;">
                            <routejump :urlNo="12">
                            <el-input  type="text" v-model="dataDetail.partcode"
                                       readonly
                                       class="mcolor"
                                       size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart()"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td style="width:60px">{{ $t('getapi[149]') }}</td>
                        <td style="width:150px;">
                            <el-input type="text" size="mini" v-model="dataDetail.partversion" :disabled="true"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[827]') }}</td>
                        <td style="width:150px;">
                            <el-input type="text" size="mini" v-model="dataDetail.item_code" :disabled="true"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[2573]') }}</td>
                        <td style="width:150px;">
                            <el-input type="number" @mousewheel.native.prevent size="mini" v-model="dataDetail.invqty" :disabled="true"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[157]') }}</td>
                        <td style="width:150px;">
                            <el-input type="number" @mousewheel.native.prevent size="mini" v-model="dataDetail.safeinventory" :disabled="true"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[145]') }}</td>
                        <td style="width:150px;">
                            <el-input type="text" size="mini" v-model="dataDetail.products" :disabled="true"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <div>
            <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
                <el-tab-pane :label="$t('getapi[7201]')" name="0">
                    <el-table
                            id="xpane-0"
                            :data="dataDetail.Lists"
                            ref="singleTable"
                            v-loading="loading"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            :height="tableHeight"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:0px"
                    >
                        <el-table-column type="selection" v-if="false"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="riqi" :label="$t('getapi[6367]')"></el-table-column>
                        <el-table-column prop="supply" :label="$t('getapi[7192]')" align="right">
                            <template slot-scope="scope">
                                {{scope.row.supply | thousandth}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="demand" :label="$t('getapi[7193]')" align="right">
                            <template slot-scope="scope">
                                {{scope.row.demand | thousandth}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="remain" :label="$t('getapi[7194]')" align="right">
                            <template slot-scope="scope">
                                {{scope.row.remain | thousandth}}
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="sr_flag" :label="$t('getapi[2285]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="sr_flag_name" :label="$t('getapi[7195]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="prior_part" :label="$t('getapi[7202]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[2203]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="partversion" :label="$t('getapi[113]')"></el-table-column>
                        <el-table-column prop="suggest_date" :label="$t('getapi[7186]')">
                            <template slot-scope="scope">
                                {{scope.row.suggest_date | toDate}}
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                            <template slot-scope="scope">
                            <el-button v-if="scope.row.prior_part != ''" @click.native.prevent="getSupplyDemandSelLine(scope.row)" type="text" size="mini">查看供需情况</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$t('getapi[148]')" name="1">
                    <!--<table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[3628]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.SchModel.planning_code"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[163]') }}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="mini" v-model="dataDetail.SchModel.planner_name"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[158]') }}</td>
                            <td style="width:150px;">
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.purchase_leadtime"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[219]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.least_purch_batch"></el-input>
                            </td>
                            <td>{{ $t('getapi[156]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.stock_upperlimit"></el-input>
                            </td>
                            <td>{{ $t('getapi[161]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.produce_leadtime"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[159]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.standard_batch"></el-input>
                            </td>
                            <td>{{ $t('getapi[157]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.stock_lowerlimit"></el-input>
                            </td>
                            <td>{{ $t('getapi[6006]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.qc_leadtime"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[164]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.package_qty"></el-input>
                            </td>
                            <td>{{ $t('getapi[165]') }}</td>
                            <td>
                                <el-input type="number" size="mini" :value="0"></el-input>
                            </td>
                            <td>{{ $t('getapi[155]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.planning_period"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[153]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.mergedays"></el-input>
                            </td>
                            <td>
                                <el-checkbox v-model="dataDetail.SchModel.is_cycle_check">循环盘点</el-checkbox>
                            </td>
                            <td>
                                盘点间隔<el-input style="width:80px" type="number" size="mini" v-model="dataDetail.SchModel.cycle_check_interval"></el-input>天
                            </td>
                            <td>{{ $t('getapi[154]') }}</td>
                            <td>
                                <el-input type="number" size="mini" v-model="dataDetail.SchModel.require_period"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td><el-checkbox></el-checkbox>客户订单限制</td>
                            <td></td>
                            <td></td>
                            <td>{{ $t('getapi[166]') }}</td>
                            <td>
                                <el-select filterable class-name="check">
                                </el-select>
                            </td>
                        </tr>
                    </table>-->
                    <table style="border-spacing: 5px" @dblclick.stop>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[221]') }}</td>
                            <td style="width:120px">
                                <el-input v-model="dataDetail.SchModel.planning_code" type="text" size="mini"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[163]') }}</td>
                            <td style="width:120px;">
                                <el-input v-model="dataDetail.SchModel.planner_name" type="text" size="mini"></el-input>
                            </td>
                            <td style="width:70px">{{ $t('getapi[158]') }}</td>
                            <td style="width:120px">
                                <el-input v-model="dataDetail.SchModel.purchase_leadtime" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[219]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.least_purch_batch" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[156]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.stock_upperlimit" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[161]') }}</td>
                            <td style="display: flex">
                                <el-input v-model="dataDetail.SchModel.produce_leadtime" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[159]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.standard_batch" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[6009]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.stock_lowest" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[6006]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.qc_leadtime" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[164]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.package_qty" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[165]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.digitscale" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[155]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.planning_period" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[153]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.mergedays" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[136]') }}</td>
                            <td style="display: flex">
                                <el-input v-model="dataDetail.SchModel.abc_category" type="text" size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[154]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.require_period" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[6007]') }}</td>
                            <td>
                                <el-checkbox v-model="dataDetail.SchModel.so_issue_control" size="mini" :true-label=1 :false-label=0></el-checkbox>
                            </td>
                            <td>{{ $t('getapi[2548]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.safe_days" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[162]') }}</td>
                            <td>
                                <el-checkbox v-model="dataDetail.SchModel.is_cycle_check" size="mini" :true-label=1 :false-label=0></el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[166]') }}</td>
                            <td>
                                <el-checkbox v-model="dataDetail.SchModel.saledemandflag" size="mini" :true-label=1 :false-label=0></el-checkbox>
                            </td>
                            <td>{{ $t('getapi[6008]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.safe_days" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[6088]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.cycle_check_interval" type="number" @mousewheel.native.prevent size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[2326]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.SchModel.routing_sequence" type="text"
                                          size="mini"></el-input>
                            </td>
                        </tr>
                    </table>
                </el-tab-pane>
            </el-tabs>
            </div>
        <!--选择物料-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/MRP/CountView/GetPartPopupList'" @callback="getpart" ref="part"></selector>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_supplydemandinfo',
        data() {
            return {
                tableOption: {
                    border: true,
                    height: window.innerHeight - 180, // 主表高度ss
                    maxHeight: window.innerHeight - 180, // 主表高度
                },
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: Common.tableHeight1, // 主表高度
                tableHeader: [],
                dataDetail: {
                    invqty: '',
                    safeinventory: '',
                    item_code: '',
                    partcode: '',
                    partversion: '',
                    products: '',
                    Lists: [],
                    SchModel:{}
                },
                ABCarr: [],
                scrollTop:0,
            };
        },
        watch: {
            'dataDetail.Lists': function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
            that.colsort();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('mrpsuggest', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6601]"),'MRP');
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'mrpsuggest');
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.isVisible = false;
                that.getView();
            },
            selectpart(row){
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data){
                let that = this
                console.log(data)
                that.dataDetail.item_code = data.item_code
                that.dataDetail.partcode = data.partcode
                that.dataDetail.partversion = data.partversion
                that.dataDetail.products = data.products
                let parm = {
                    part_code: data.partcode,
                    part_version: data.partversion
                }
                that.getDetail(parm)
            },
            getDetail(parm){
                let that = this
                that.$http.urlpost('/MRP/CountView/GetSupplyDemandInfo', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent;
                        that.dataDetail.invqty = data.invqty
                        that.dataDetail.safeinventory = data.safeinventory
                        that.dataDetail.Lists = data.Lists
                        that.dataDetail.SchModel = data.SchModel
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            },
            getSupplyDemandSelLine(val){
                let that = this
                let parm = {
                    prior_part: val.prior_part
                }
                
                that.$http.urlpost('/MRP/CountView/GetSupplyDemandSelLine', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.Info;
                        if(data.type == 'mrp'){
                            that.dataDetail.item_code = data.item_code
                            that.dataDetail.partcode = data.part_code
                            that.dataDetail.partversion = data.part_version
                            that.dataDetail.products = data.products
                            let parm = {
                                part_code: data.part_code,
                                part_version: data.part_version
                            }
                            that.getDetail(parm)
                        }else if(data.type == 'mps'){
                            // console.log("测试mps:"+JSON.stringify(data))
                            let item = {
                                label: '主计划供需',
                                name: '2_mainsupply',
                                path: '/mainsupply',
                                url: '/mainsupply',
                                params: data,
                                query: data,
                                icon: 'video-play'
                            };
                            that.$router.push({ path: '/mainsupply', query: data });
                            that.$store.commit('selectMenu', item);
                            that.$limits.cachePage(item)
                        }
                    } else {
                        that.$message.error(res.Msg);
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
